import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { EstateService } from 'src/app/services/estate.service';

import * as taxBandsActions from './taxbands.actions';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { TaxBandsService } from 'src/app/services/tax-bands.service';
import { ITaxBand } from 'src/app/models/ITaxBand';
import { HttpErrorResponse } from '@angular/common/http';
import { interpretApiError } from 'src/app/helpers/InterpretateApiError';
import { HttpVerbType } from 'src/app/enums/HttpVerbType';
import * as categoryEditorActions from '../categories/categories.actions';

@Injectable()
export class TaxBandsEffects {
  constructor(private action$: Actions,
    private estateService: EstateService,
    private taxBandsService: TaxBandsService) {

  }

  loadTaxBands$ = createEffect(
    () => this.action$.pipe(
      ofType(taxBandsActions.TaxBandsActionTypes.LoadTaxBands),
      mergeMap((action: taxBandsActions.LoadTaxBands) =>
        this.taxBandsService.GetTaxBands(this.estateService.CorporationID, this.estateService.SelectedSite.siteId).pipe(
          map((taxBands: ITaxBand[]) => new taxBandsActions.LoadTaxBandsSuccessful(taxBands)),
          catchError((error: HttpErrorResponse) => of(new taxBandsActions.LoadTaxBandsFailed(interpretApiError(error))))
        )
      ))
  );

  saveTaxBands$ = createEffect(
    () => this.action$.pipe(
      ofType(taxBandsActions.TaxBandsActionTypes.SaveTaxBands),
      mergeMap((action: taxBandsActions.SaveTaxBands) =>
        this.taxBandsService.SaveTaxBands(this.estateService.CorporationID, this.estateService.SelectedSite.siteId, action.payload).pipe(
          map((taxBands: ITaxBand[]) => new taxBandsActions.SaveTaxBandsSuccessful(taxBands)),
          catchError((error: HttpErrorResponse) => of(new taxBandsActions.SaveTaxBandsFailed(interpretApiError(error, HttpVerbType.POST), action.payload)))
        )
      ))
  );

  saveTaxBandsSuccessful$ = createEffect(
    () => this.action$.pipe(
      ofType(taxBandsActions.TaxBandsActionTypes.SaveTaxBandsSuccessful),
      mergeMap(() =>
        of(new categoryEditorActions.ResetStore())
      )
    )
  );
}
